export const SCROLL_PANEL_SPEED = 35;
